import {takeEvery, put, fork, call, all, /*select*/ } from 'redux-saga/effects';
import { actions as servItemReducerActions, callTypes as servItemReducerCallTypes } from "./serviceItemSlice"
import { getAllServiceItemsForServiceApi, searchServiceItemsForServiceApi } from "./serviceItemAPI";
import * as uis from "../../../UI/redux/uiSlice";

export function* onLoadServItemsForServicesStartAsync({payload}){

    try{
        
        yield put(servItemReducerActions.startCall({ callType: servItemReducerCallTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);

        // let reqBody = {
        //     username: auth.userName,
        //     sessionKey: auth.sessionKey,
        //     serviceId: payload.serviceId
        // };

        // const response = yield call(getAllServiceItemsForServiceApi, reqBody);
        
        let reqBody = {
            idOne: payload.provId,
            idTwo: payload.deptId,
            idThree: payload.serviceId
        };

        const response = yield call(getAllServiceItemsForServiceApi, reqBody);        

        if(response.status === 200){
            let entities = response.data;
            let totalCount = entities.length;
            yield put(servItemReducerActions.servItemsLoaded({entities, totalCount}));
        }
    }
    catch(error){

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error retrieving the service item information."
        // }));

        yield put(servItemReducerActions.catchError({
            callType: servItemReducerCallTypes.list,
            error: "There was an error retrieving the service item information."
        }));

    }

}


export function* onSearchServItemsForServiceStartAsync({payload}){

    try{
        
        yield put(servItemReducerActions.startCall({ callType: servItemReducerCallTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);

        // let reqBody = {
        //     username: auth.userName,
        //     sessionKey: auth.sessionKey,
        //     serviceId: payload.serviceId
        // };

        // const response = yield call(searchServiceItemsForServiceApi, reqBody); 

        let reqBody = {
            idOne: payload.provId,
            idTwo: payload.deptId,
            idThree: payload.serviceId,
            str: payload.query
        };

        const response = yield call(searchServiceItemsForServiceApi, reqBody);        

        if(response.status === 200){
            let entities = response.data;
            let totalCount = entities.length;
            yield put(servItemReducerActions.servItemsLoaded({entities, totalCount}));
        }
    }
    catch(error){

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error while searching for the service item information."
        // }));

        yield put(servItemReducerActions.catchError({
            callType: servItemReducerCallTypes.list,
            error: "There was an error while searching for the service item information."
        }));

    }

}

export const actionTypes = {
    FetchAllServItems: "[FetchAllServItems] Fetch All Service Items API Action",
    SearchServItemsUnderService: "[SearchServItemsUnderService] Search Service Items Under Service API Action",

  };

export const actions = {

    fetchAllServItemsForService: (serviceId, deptId, provId) => ({ type: actionTypes.FetchAllServItems, payload: { serviceId, deptId, provId } }),
    searchServItemsUnderService: (query, serviceId, deptId, provId) => ({ type: actionTypes.SearchServItemsUnderService, payload: { query, serviceId, deptId, provId } }),


  };

export function* fetchAllServItemsForService(){

    yield takeEvery(actionTypes.FetchAllServItems,onLoadServItemsForServicesStartAsync);    
}

export function* searchServItemsUnderService(){

    yield takeEvery(actionTypes.SearchServItemsUnderService,onSearchServItemsForServiceStartAsync);    
}



const fSagas = [
    fork(fetchAllServItemsForService),
    fork(searchServItemsUnderService),

];

export function* saga(){
    yield all ([...fSagas]);
}




